import { createAction, props } from '@ngrx/store';
import { ProjektItem } from '../../projekt.model';

export const loadProjekteStart = createAction('PROJEKTVERWALTUNG::LOAD_PROJEKTE_START');
export const loadProjekteSucceeded = createAction(
    'PROJEKTVERWALTUNG::LOAD_PROJEKTE_SUCCEEDED',
    props<{ item: ProjektItem[] }>(),
);
export const loadProjekteFailed = createAction('PROJEKTVERWALTUNG::LOAD_PROJEKTE_FAILED', props<{ error: Error }>());
